import { HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

import Builder from '@/components/layout/Builder'
import HeroOnlyText from '@/components/sections/HeroOnlyText'
import { useLenis } from '@/contexts/lenis'
import { useLoaderStore } from '@/store/loader'

import { WPPageData } from '@/types'

export type CollectionProps = HTMLAttributes<HTMLElement> & {
  pageData?: WPPageData
}

const Collection = ({ pageData }: CollectionProps) => {
  const wrapper = useRef<HTMLDivElement>(null!)
  const loaded = useLoaderStore((state) => state.pageLoaded)
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!lenis || !loaded) return
      const pinnedElement = document.querySelector('[data-hero]')
      let pinTrigger: ScrollTrigger | undefined

      if (pinnedElement) {
        const tlHero = gsap.timeline({}).fromTo(
          pinnedElement,
          {
            autoAlpha: 1
          },
          { autoAlpha: 0 }
        )
        pinTrigger = ScrollTrigger.create({
          trigger: wrapper.current,
          animation: tlHero,
          scrub: true,
          pin: pinnedElement,
          pinType: 'fixed',
          pinSpacing: false,
          start: 'top bottom',
          end: 'top top',
          invalidateOnRefresh: true
        })
      }

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: wrapper.current,
          invalidateOnRefresh: true,
          scrub: 0.5,
          start: 'top 90%',
          end: 'top 20%'
        }
      })

      return () => {
        timeline.kill()
        if (pinTrigger) pinTrigger.kill()
      }
    },
    {
      dependencies: [lenis, loaded],
      scope: wrapper,
      revertOnUpdate: true
    }
  )

  return (
    <>
      {pageData ? <HeroOnlyText {...pageData.acf.hero} /> : null}
      <div ref={wrapper}>
        <Builder pageData={pageData} />
      </div>
    </>
  )
}

export default Collection
